import { getImageUrl } from "@/javascript/functions/images";
import handleVideoPlayer from '@/javascript/new_site/modules/handleVideoPlayer'
import showSideBarSection from '@/javascript/new_site/modules/showSidebarSection'

const multipleSelect = () => {
  const generateId = () => {
    return Math.random() * 1123049812
  }

  function cleanFormSelect(el) {
    const $parent = $(el).parents('.dse-select__multiple')
    const $selectedOptions = $parent.find('option:selected')

    $selectedOptions.prop("selected", false)

    $parent.find("input[type='checkbox']:checked").each(function (_, check) {
      $(check).prop('checked', false)
    })

    $($parent).find('.dse-select__multiple__selecteds--items').text('')
    $($parent)
    .find('.dse-select__multiple__selecteds--total')
    .css('display', 'none')
    .text('0')

    $parent.removeClass('dse-select__multiple--focused')
  }

  function toogleActiveSelect(el) {
    const $options = $(el).find("input[type='checkbox']:checked")
    let display = 'none'
    if ($options.length) {
      el.addClass('dse-select__multiple--focused')
    } else {
      el.removeClass('dse-select__multiple--focused')
    }

    if ($options.length >= 1) {
      display = 'flex'
    }

    el
    .find('.dse-select__multiple__selecteds--total')
    .css('display', display)
    .html($options.length)
  }

  function getSelecteds(el) {
    const $parent = $(el).parents('.dse-select__multiple')
    const name = $(el).attr('name')
    const elements = $(`input[name='${name}']:checked`)
    const texts = {}
    let selecteds = []

    elements.each(function (_, item) {
      const val = $(item).val()
      texts[val] = val
    })

    $parent.find('select option').each(function (_, item) {
      let $item = $(item)
      if (texts[$item.val()]) {
        selecteds.push($item.text())
        $item.prop('selected', true)
      } else {
        $item.prop('selected', false)
      }
    })

    $($parent)
    .find('.dse-select__multiple__selecteds--items')
    .text(selecteds.toString())

    toogleActiveSelect($parent)
  }

  function filterList(el, list) {
    const elements = $(list).find('.dse-input__option-text')
    const value = $(el).val().toLowerCase()

    $(elements).each(function (index, item) {
      const val = $(item)
      .text()
      .toLowerCase()
      .replace(/[\r\n]/gm, '')
      const parent = $(item).parents(
      '.dse-select__multiple__list__item.__options'
      )

      $(parent).css('display', 'none')
      if (val.match(value)) {
        const el = parent
        $(parent).css('display', 'block')
      }
    })
  }

  $('.dse-select__multiple').each(function () {
    let templateOptions = ''

    const parentElement = this
    const $this = $(this)
    const label = $this.find('select').data('label')
    const actions = $this.find('select').data('actions')
    const search = $this.find('select').data('search')
    let $select = $this.find('select')
    let selectName = $select.attr('name')

    $select.children('option, optgroup').each(function () {
      const $that = $(this);
      const id = generateId()

      if($that.is('option')) {
        const val = $that.val()
        const text = $that.text()
        const checked = $that.prop('selected')

        templateOptions += `
          <li class="dse-select__multiple__list__item __options">
            <div class="dse-input-option">
              <input type="checkbox" name="${selectName}" id="${id}" data-checked="${checked}" value="${val}" />
              <label for="${id}">${text}</label>
            </div>
          </li>
        `
      } else if ($that.is('optgroup')) {
        const val = $that.attr('label')
        let subOptions = ''

        $that.children('option').each(function () {
          let $this = $(this)
          const val = $this.val()
          const text = $this.text()
          const checked = $this.prop('selected')
          const idOption = generateId()

          subOptions += `
          <li class="dse-select__multiple__list__item __options">
            <div class="dse-input-option">
              <input type="checkbox" name="${selectName}" id="${idOption}" data-checked="${checked}" value="${val}" />
              <label for="${idOption}">${text}</label>
            </div>
          </li>
        `
        })

        templateOptions += `
          <li class="dse-select__multiple__list__item2">
            <div class="dse-input-option2">
              <div class="optgroup-list">${val}</div>
              <ul>
                ${subOptions}
              </ul>
            </div>
          </li>
        `
      }
    })

    const inputId = generateId()

    const inputList = search !== false ? `
      <li class="dse-select__multiple__list__item">
        <div class="dse-input">
          <label for="${inputId}">Digite um termo</label>
          <input type="text" name="query" id="${inputId}" />
        </div>
      </li>
    ` : ''

    const inputListActions = actions !== false ? `
      <li class="dse-select__multiple__actions">
        <button type="button" class="dse-select__multiple__clean">Limpar</button>
        <button class="dse-button__primary"><div style="z-index: 99">Ver resultados</div></button>
      </li>
    ` : ''

    const listHeader = `
      <div class="dse-select__multiple__selecteds">
        <label class="dse-select__multiple__label">${label}</label>
        <span class="dse-select__multiple__selecteds--items"></span>
        <span class="dse-select__multiple__selecteds--total"></span>
        <span class="dse-select__multiple__selecteds--arrow"></span>
      </div>
    `

    const list = `${listHeader}<ul class="dse-select__multiple__list dse-input__primary">${inputList}<li class="dse-select__multiple__list__item py-2"><ul class="dse-select__multiple__list__options">${templateOptions}</ul></li>${inputListActions}</ul>`

    $(this).append(list)

    setTimeout(() => {
      $(this)
      .find("input[type='checkbox']")
      .each(function (_, item) {
        const checked = $(item).attr('data-checked')
        if (checked === 'true') {
          $(item).click()
          getSelecteds(item)
        }
      })

      $(this)
      .find('.dse-select__multiple__clean')
      .each(function (_, el) {
        $(el).click(function () {
          cleanFormSelect(el)
        })
      })

      $(this)
      .find("input[type='checkbox']")
      .each(function (_, el) {
        $(el).change(function () {
          getSelecteds(el)
        })
      })

      $(this)
      .find("input[type='text']")
      .each(function (_, el) {
        $(el).on('input', () => {
          filterList(el, parentElement)
        })
      })

      $(this)
      .find('.dse-select__multiple__selecteds')
      .click(function () {
        $('.dse-select__multiple--open').removeClass(`dse-select__multiple--open`)

        const list = $(this).next('.dse-select__multiple__list ')
        $(list)
        .stop(true, true)
        .toggle(1, function (e) {
          $('.dse-select__multiple__list').not(this).css('display', 'none')

          const isVisible = $(list).is(':visible')

          if (isVisible) {
            $(parentElement).addClass(`dse-select__multiple--open`)

            $('html body').on('click', (event) => {
              const parentClass = $(event.target).parents(
              '.dse-select__multiple'
              )

              if (!parentClass.length) {
                $(list).stop(true, true).css('display', 'none')
                $('.dse-select__multiple--open').removeClass(`dse-select__multiple--open`)
              }
            })
          } else {
            $('html body').off('click')
          }
        })
      })
    }, 600)
  })
}

// MODAL.js

const createUserHeader = (user) => {
  return `
    <div class="modal-portfolio__side-bar__user section-separator">
      <div class="modal-portfolio__side-bar__user__picture">
        <div class="user_space_avatar user_space_avatar--small">
          <img src="${user.photo}"alt="${user.name}"/>
        </div>
      </div>
      <h3 class="modal-portfolio__side-bar__user__name">${user.name}</h3>
    </div>
  `
}

const sideBar = (info, index) => {
  const display = index === 0 ? 'block' : 'none'

  let user_header = ''
  let experiences = ''
  let tools = ''
  let skills = ''

  user_header += createUserHeader(info.user)
  $('.modal-portfolio__side-bar__wrapper').css('display', 'none')

  info.skills.forEach((skill) => {
    skills += `<div class="box-tag"><a href="#!" class="portfolio-tag portfolio-tag__acting">${skill}</a></div>`
  })

  info.tools.forEach((tool) => {
    tools += `<div class="box-tag"><a href="#!" class="portfolio-tag portfolio-tag__tools">${tool}</a></div>`
  })

  info.experiences.forEach((experience) => {
    experiences += `<div class="box-tag"><a href="#!" class="portfolio-tag portfolio-tag__general-tags">${experience}</a></div>`
  })

  return `
    <div data-side-bar-id="${info.video_id}" class="modal-portfolio__side-bar__wrapper active" style="display: ${display}">
      ${user_header}
      <div class="modal-portfolio__side-bar__info section-separator">
        <h3 class="modal-portfolio__side-bar__title">Atuação</h3>
        <ol class="modal-portfolio__side-bar__info__tags">
            ${skills}
        </ol>
      </div>

      <!-- Ferramentas -->
      <div class="modal-portfolio__side-bar__tags section-separator">
        <h3 class="modal-portfolio__side-bar__title">Ferramentas</h3>
        <ol class="modal-portfolio__side-bar__info__tags">
          ${tools}
        </ol>
      </div>

      <!-- Tags -->
      <div class="modal-portfolio__side-bar__tags section-separator">
        <h3 class="modal-portfolio__side-bar__title">Tags</h3>
        <ol class="modal-portfolio__side-bar__info__tags">
          ${experiences}
        </ol>
      </div>

      <!-- Descrição -->
      <div class="modal-portfolio__side-bar__description section-separator">
        <h3 class="modal-portfolio__side-bar__title">Descrição</h3>

        <div class="modal-portfolio__side-bar__description__text text--hidden">
          <p>${info.description}</p>
        </div>
        <a href="#!" class="modal-portfolio__side-bar__description__text__more read-more">ver mais</a>
      </div>
      <div class="modal-portfolio__side-bar__call-to-action section-separator">
        <a href="${info.budget_link}" class="dse-button-link link-theme____neutral__outlined icon--right">
          <i>
            <img class="svg-icon" width="24px" height="24px" src="${getImageUrl('my_page/clipboard-dollar.svg')}" title="Icone Play" />
          </i>
          <span>Solicitar orçamento</span>
        </a>
      </div>
    </div>
  `
}

const finishCarousel = (event) => {
  const videoId = $(`.modal-portfolio__video__wrapper:eq(${event.item.index})`).data('video-url')
  showSideBarSection(videoId)

//  const url = window.location.href.split('/')
//  const deleteId = url.slice(0, -1)

//  const newUrl = deleteId.join('/') + '/' + videoId

//  console.log(newUrl)

//  changeURL(newUrl)
  handleVideoPlayer(event.item.index)
}

const createOwlSlider = (slide, buttonNext, buttonPrev, videoId) => {
  const owl = $(slide).owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    onTranslate: finishCarousel,

    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: false,
      },
      600: {
        items: 1,
        nav: false,
        dots: false,
      },
      1000: {
        items: 1,
        nav: false,
        loop: false,
        dots: false,
      },
    },
  })

  owl.owlCarousel()
  // Go to the next item
  $(buttonNext).click(function () {
    owl.trigger('next.owl.carousel')
  })
  // Go to the previous item
  $(buttonPrev).click(function () {
    // With optional speed parameter
    // Parameters has to be in square bracket '[]'
    owl.trigger('prev.owl.carousel', [300])
  })

  if (videoId) {
    $('.modal-portfolio__video__wrapper').each(function (index, value) {
      const modalVideoId = $(value).data('video-url')

      if (modalVideoId === videoId) {
        owl.trigger('to.owl.carousel', index)
      }
    })
  }
}

const modal_video_wrapper = (item)=> {
  return `
      <div class="modal-portfolio__video__wrapper flex-group" data-video-url="${item.video_id}">
          <div class="modal-portfolio__video__player">
          <div data-video-id="${item.video}" class="data-video-id">
            <iframe src="${item.video}" style=" border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="allowfullscreen"></iframe>
          </div>
          </div>
          <div class="modal-portfolio__video__top-group">
          <div class="modal-portfolio__video__title">
             ${item.title}
          </div>
          <div class="modal-portfolio__video__social">
            <!--<a href="#!">
              <img class="svg-icon" width="24px" height="24px" src="${getImageUrl('my_page/heart.svg')}" title="Icone Play" />
            </a>

            <a href="#!">
              <img class="svg-icon" width="24px" height="24px" src="${getImageUrl('my_page/send-2.svg')}" title="Icone Play" />
            </a>

            <a href="#!">
              <img class="svg-icon" width="24px" height="24px" src="${getImageUrl('my_page/archive-add.svg')}" title="Icone Play" />
            </a>-->
          </div>
          </div>
      </div>
    `
}

const mountModal = (items, videoId) => {
  $('.modal-portfolio__carousel').html('')

  let input_video = ''
  let side_bar = ''

  items.forEach(function (item, index) {
    side_bar += sideBar(item, index)
    input_video += modal_video_wrapper(item)
  })

  $('.modal-portfolio__carousel').html(input_video)
  $('.modal-portfolio__side-bar').html(side_bar)

  setTimeout(() => {
    $('.modal-portfolio__carousel').trigger('destroy.owl.carousel')
    createOwlSlider('.modal-portfolio__carousel', '.arrow-right', '.arrow-left', videoId)
    readMoreLess();
    scrollbarVisible()
  }, 500);

  $(".modal-portfolio").fadeIn();

  $('.svg-icon').each((_, item) => SVGInject(item))
}

const MyPageIndex = () => {
  const slickFabric = (slide, buttonNext, buttonPrev) => {
    const owl = $(slide).owlCarousel({
      loop: true,
      margin: 10,
      responsiveClass: true,
      navText: [`<img src="${getImageUrl('my_page/arrow-left.svg')}" class="svg-icon-carousel" />`, `<img src="${getImageUrl('my_page/arrow-right.svg')}" class="svg-icon-carousel" />`],
      responsive: {
        0: {
          items: 1,
          nav: true,
          dots: false,
          center: true,
        },
        600: {
          items: 1,
          nav: true,
          dots: false,
        },
        1000: {
          items: 5,
          nav: true,
          center: false,
          loop: false,
          dots: false,
        },
      },
    })

    owl.owlCarousel()
    // Go to the next item
    $(buttonNext).click(function () {
      owl.trigger('next.owl.carousel')
    })
    // Go to the previous item
    $(buttonPrev).click(function () {
      // With optional speed parameter
      // Parameters has to be in square bracket '[]'
      owl.trigger('prev.owl.carousel', [300])
    });

    $('.svg-icon-carousel').each((_, item) => SVGInject(item))
    owl.data('owl.carousel')._invalidated.width = true;
    owl.trigger('refresh.owl.carousel');
  }

  const slickSlide = () => {
    $('.slide_carousel__wrapper').each(function () {
      const slick = $(this).find('.slide__slick')
      const buttonNext = this.querySelectorAll('.slide__carousel__button--next')
      const buttonPrev = this.querySelectorAll('.slide__carousel__button--prev')

      slickFabric(slick, buttonNext, buttonPrev)
    })
  }

  $(document).ready(() => {
    slickSlide()

    $('#close__form__modal').click(() => {
      $('.modal__form').stop(true, true).fadeOut()
    })

    $('#open__form__modal').click(() => {
      $('.modal__form').stop(true, true).fadeIn()
    })

    $('#unslick').click(() => {
      // $(".slide__slick").slick("unslick")
    })

    $('.modal-portfolio__close').click(() => {
      $('.modal-portfolio').stop().fadeOut()
      handleVideoPlayer()
      // window.history.pushState('', '', '/')
    })

    $('.video__thumb').on('click',function(){
      let id = $(this).data('page-id')
      const videoId = $(this).data('videoUrl')
      mountModal(videoList[id], videoId)
    })
  })

  multipleSelect()

  log("MY PAGE INDEX")
}

export default MyPageIndex
